import type { BrowserCall, CallTicketCandidate, PhoneState } from './types';

export type PresentedTicketCandidate = CallTicketCandidate & {
  displayNumber: string;
  statusLabel: string;
  updatedLabel: string;
};

export type InboundTicketSelectionState = {
  visible: boolean;
  enabled: boolean;
  hint: string;
  candidates: PresentedTicketCandidate[];
};

const STATUS_LABELS: Record<string, string> = {
  NEW: 'Новая',
  DISTRIBUTION: 'На распределении',
  IN_PROGRESS: 'В работе',
  WAITING_CLIENT: 'Ожидает клиента',
  WAITING_APPROVAL: 'На согласовании',
  SUSPENDED: 'Приостановлена',
};

function updatedLabel(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Время не указано';
  const parts = new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) => (
    parts.find(item => item.type === type)?.value || ''
  );
  return `${part('day')}.${part('month')}, ${part('hour')}:${part('minute')}`;
}

export function ticketCandidatePresentation(
  candidate: CallTicketCandidate,
): PresentedTicketCandidate {
  const normalizedStatus = String(candidate.status || '').toUpperCase();
  return {
    ...candidate,
    displayNumber: `ИГ-${candidate.number}`,
    statusLabel: STATUS_LABELS[normalizedStatus] || normalizedStatus || 'Статус не указан',
    updatedLabel: updatedLabel(candidate.updatedAt),
  };
}

export function inboundTicketSelection(
  call: BrowserCall | null,
  phoneState: PhoneState,
): InboundTicketSelectionState {
  const candidates = (call?.active_tickets || []).map(ticketCandidatePresentation);
  const visible = Boolean(
    call?.direction === 'INBOUND'
    && !call.ticket_id
    && call.ticket_selection_required
    && candidates.length > 0,
  );
  if (!visible) {
    return { visible: false, enabled: false, hint: '', candidates: [] };
  }

  const enabled = phoneState === 'ACTIVE' || phoneState === 'HOLD';
  return {
    visible: true,
    enabled,
    hint: enabled ? '' : 'Сначала примите звонок',
    candidates,
  };
}
